<template>
  <div class="flex flex-between">
    <comm-button-call
      :contact="contactClone"
      :record="recordClone"
      :include-button-text="includeButtonText"
      :is-primary="isPrimary"
      :size="size"
      :can-call="canCall"
      :available-records="availableRecords"
      @openModal="callButtonClick"
    />

    <button-outlined
      v-if="includeButtonText"
      @click="textButtonClick"
      class="mx-50"
      icon-left="message"
      :color="canText ? buttonColor : ''"
      :disabled="!canText"
      :title="textTitleText"
      :size="size"
      :is-short="size === 'is-small'"
    >Text
    </button-outlined>
    <button-icon
      v-else
      @click="textButtonClick"
      class="mx-50"
      icon="text"
      :color="canText ? buttonColor : ''"
      :disabled="!canText"
      :title="textTitleText"
    ></button-icon>

    <button-outlined
      v-if="includeButtonText"
      @click="emailButtonClick"
      icon-left="email"
      :color="canEmail ? buttonColor : ''"
      :title="emailTitleText"
      :size="size"
      :is-short="size === 'is-small'"
    >Email
    </button-outlined>
    <button-icon
      v-else
      @click="emailButtonClick"
      icon="email"
      :color="canEmail ? buttonColor : ''"
      :title="emailTitleText"
    ></button-icon>

    <modal-container>
      <comm-call-modal
        v-if="canCall"
        ref="commCallModal"
        :contact="contactClone"
        :record="recordClone"
        :available-records="availableRecords"
      ></comm-call-modal>

      <comm-text-modal
        v-if="canText"
        ref="commTextModal"
        :contact="contactClone"
        :record="recordClone"
        :available-records="availableRecords"
      ></comm-text-modal>

      <comm-email-modal
        v-if="canEmail"
        ref="commEmailModal"
        :contact="contactClone"
        :record="recordClone"
        :available-records="availableRecords"
      ></comm-email-modal>
    </modal-container>
  </div>
</template>

<script>
import CommCallModal from "./CommCallModal";
import CommTextModal from "./CommTextModal";
import CommEmailModal from "./CommEmailModal";
import CommButtonCall from "./components/CommButtonCall.vue";

export default {
  name: "CommButtons",
  components: {
    CommButtonCall,
    CommEmailModal,
    CommTextModal,
    CommCallModal
  },
  props: {
    contact: {
      type: Object,
      required: true,
    },
    record: Object,
    availableRecords: Array,
    includeButtonText: {
      type: Boolean,
      default: false
    },
    isPrimary: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: ""
    },
  },
  data() {
    return {
      isLoading: false,
      // These are cloned because incoming props may be from computed sources that change while the comms are open, and we don't want them to change.
      contactClone: this.contact ? this.$utils.clone(this.contact) : null,
      recordClone: this.record ? this.$utils.clone(this.record) : null,
    };
  },
  watch: {
    "contact"() {
      this.contactClone = this.contact ? this.$utils.clone(this.contact) : null
    }
  },
  computed: {
    buttonColor() {
      return this.isPrimary ? "is-primary" : "is-secondary";
    },
    hasPhoneIntegration() {
      return this.$store.getters.hasPhoneIntegration;
    },
    canCall() {
      return this.hasPhoneIntegration
        && (this.contactClone.phone_1 || this.contactClone.phone_2)
        && (!this.contactClone.is_phone_one_on_do_not_contact_list || !this.contactClone.is_phone_two_on_do_not_contact_list);
    },
    canEmail() {
      return this.$store.getters.emailIsIntegrated
        && this.contactClone.email_address
        && this.contactClone.is_mailable;
    },
    emailTitleText() {
      if (this.canEmail) {
        return "Email Contact";
      }

      if (!this.$store.getters.emailIsIntegrated) {
        return "Email is not set up";
      }

      return "Contact has no email";
    },
    canText() {
      return this.hasPhoneIntegration
        && (this.contactClone.phone_1 || this.contactClone.phone_2)
        && (!this.contactClone.is_phone_one_on_do_not_contact_list || !this.contactClone.is_phone_two_on_do_not_contact_list);
    },
    textTitleText() {
      if (this.canCall) {
        return "Text Contact";
      }

      if (!this.hasPhoneIntegration) {
        return "Phone is not set up";
      }

      return "Contact has no available phone numbers";
    },
  },
  methods: {
    cloneContactAndRecord() {
      this.contactClone = this.contact ? this.$utils.clone(this.contact) : null
      this.recordClone = this.record ? this.$utils.clone(this.record) : null
    },
    callButtonClick() {
      this.cloneContactAndRecord();
      this.$refs.commCallModal.open();
    },
    textButtonClick() {
      this.cloneContactAndRecord();
      this.$refs.commTextModal.open();
    },
    emailButtonClick() {
      if (this.canEmail) {
        this.cloneContactAndRecord();
        this.$refs.commEmailModal.open();
        return;
      }

      if (!this.$store.getters.emailIsIntegrated) {
        return this.$utils.confirm("Set up email integration and start sending emails. Do you want to setup one?", "Email is not set up")
          .then(() => {
            this.$router.push({name: "settings"});
            this.$router.replace({params: {tab: "email", query: ""}});
          });
      }

      this.$buefy.dialog.alert({
        message: "Contact has no email",
        type: "is-info"
      });
    }
  }
};
</script>
